export default class VidioAspectRatio {
  constructor(tech) {
    this._tech = tech;
  }

  tech() {
    return this._tech;
  }

  init() {
    this.tech().one('playing', this.setVideoObjectFit.bind(this));
    this.tech().on('fullscreenchange', this.setVideoObjectFit.bind(this));
  }

  setVideoObjectFit() {
    const video = document.querySelector('video');

    if (video && this.videoMediaIsLandscape(video) && this.videoElementIsLandscape(video) && !this.inFullscreenMode()) {
      video.style.objectFit = "unset";
    } else {
      video.style.objectFit = "contain";
    }
  }

  videoMediaIsLandscape(video) {
    return video.videoHeight < video.videoWidth;
  }

  videoElementIsLandscape(video) {
    return video.clientHeight < video.clientWidth;
  }

  inFullscreenMode() {
    const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;

    if (!fullscreenElement) return false;

    return fullscreenElement.classList.contains('vjs-fullscreen');
  }
}
